import { render, staticRenderFns } from "./HomeInfoAbatedor.vue?vue&type=template&id=fa47bb80&scoped=true&"
import script from "./HomeInfoAbatedor.vue?vue&type=script&lang=js&"
export * from "./HomeInfoAbatedor.vue?vue&type=script&lang=js&"
import style0 from "./HomeInfoAbatedor.vue?vue&type=style&index=0&id=fa47bb80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa47bb80",
  null
  
)

export default component.exports